import { AutomationValue } from './AutomationValue.js';

/**
 * AutomationCondition  (generic CompareCondition)
 *
 * A platform-independent binary comparison.
 * Does not reference Blockly or Home Assistant.
 *
 * left operator right
 *
 * Examples:
 *   val == 0          → left=ref('val'), op='==', right=literal('0')
 *   brightness > 50   → left=ref('brightness'), op='>', right=literal('50')
 *
 * Generators translate conditions into their target format.
 * The HA Generator emits: value_template: "{{ left op right }}"
 */
export class AutomationCondition {
  /**
   * @param {object} config
   * @param {string}         [config.id]
   * @param {AutomationValue} config.left      — left-hand operand
   * @param {string}          [config.operator] — '==' | '!=' | '>' | '<' | '>=' | '<='
   * @param {AutomationValue} config.right     — right-hand operand
   */
  constructor({ id, left, operator = '==', right } = {}) {
    this.id       = id ?? crypto.randomUUID();
    this.operator = operator;
    this.left     = left  instanceof AutomationValue ? left  : AutomationValue.fromJSON(left);
    this.right    = right instanceof AutomationValue ? right : AutomationValue.fromJSON(right);
  }

  toJSON() {
    return {
      id:       this.id,
      left:     this.left?.toJSON()  ?? null,
      operator: this.operator,
      right:    this.right?.toJSON() ?? null,
    };
  }

  static fromJSON(data) {
    if (!data) return null;
    return new AutomationCondition(data);
  }
}
